module.exports = {
  platform: 'voice',
  name: 'Disconnect',
  node: 'disconnect',
  bg: '#FFFFFF',
  note: '',
  property: {
    vxml: ''
  }
}
